import { render } from "./ProductsIndex.vue?vue&type=template&id=7044dcbd"
import script from "./ProductsIndex.vue?vue&type=script&lang=js"
export * from "./ProductsIndex.vue?vue&type=script&lang=js"

import "./ProductsIndex.vue?vue&type=style&index=0&id=7044dcbd&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__